/** A sentence that ends in exactly one full stop, whatever the text it was made from ended in. */
export function endWithPeriod(text: string): string {
  const trimmed = text.trim().replace(/[.\s]+$/, "");
  return trimmed ? `${trimmed}.` : "";
}

/** "The agent is unavailable: <reason>." for the panel and the foot of the page. */
export function agentUnavailableSentence(reason: string | null | undefined): string {
  return `The agent is unavailable: ${endWithPeriod(reason ?? "") || "no reason was given."}`;
}
